import { render, staticRenderFns } from "./attendanceSection.vue?vue&type=template&id=08d8fcad&scoped=true&"
import script from "./attendanceSection.vue?vue&type=script&lang=js&"
export * from "./attendanceSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d8fcad",
  null
  
)

export default component.exports